"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormatValue = void 0;

var _constants = require("@kepler.gl/constants");

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
var getFormatValue = function getFormatValue(fmt) {
  return fmt[_constants.TOOLTIP_KEY];
};

exports.getFormatValue = getFormatValue;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9mb3JtYXQudHMiXSwibmFtZXMiOlsiZ2V0Rm9ybWF0VmFsdWUiLCJmbXQiLCJUT09MVElQX0tFWSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUhBO0FBQ0E7QUFJTyxJQUFNQSxjQUFjLEdBQUcsU0FBakJBLGNBQWlCLENBQUFDLEdBQUc7QUFBQSxTQUFJQSxHQUFHLENBQUNDLHNCQUFELENBQVA7QUFBQSxDQUExQiIsInNvdXJjZXNDb250ZW50IjpbIi8vIFNQRFgtTGljZW5zZS1JZGVudGlmaWVyOiBNSVRcbi8vIENvcHlyaWdodCBjb250cmlidXRvcnMgdG8gdGhlIGtlcGxlci5nbCBwcm9qZWN0XG5cbmltcG9ydCB7VE9PTFRJUF9LRVl9IGZyb20gJ0BrZXBsZXIuZ2wvY29uc3RhbnRzJztcblxuZXhwb3J0IGNvbnN0IGdldEZvcm1hdFZhbHVlID0gZm10ID0+IGZtdFtUT09MVElQX0tFWV07XG4iXX0=